// https://reactjs.org/docs/javascript-environment-requirements.html
import 'core-js/es/map';
import 'core-js/es/set';
import 'raf/polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import {Flip, ToastContainer} from 'react-toastify';
import {HelmetProvider} from 'react-helmet-async';
import {I18nextProvider} from 'react-i18next';
import {Provider} from 'react-redux';
import store from 'store';

// Styles
import 'normalize.css';
import 'react-toastify/dist/ReactToastify.css';
import 'styles/main.scss';

// 新版首页(v3)样式体系。顺序有依赖，勿调整：
// tailwind.css 是 npm run tailwind 的产物；base.css 的作用域 reset 必须早于 custom.css，
// 否则 `.v3-scope *` 的 border 基线会盖掉 `.glass-card` 的边框（两者同为 0,1,0 优先级）。
import 'styles/v3/tailwind.css';
import 'styles/v3/base.css';
import 'styles/v3/custom.css';
// 文档排版（.v3-prose，Prose 组件配套），置于 base.css reset 之后
import 'styles/v3/prose.css';

import App from 'containers/App';

// i18n 初始化必须在任何组件渲染前完成（检测语言并 init 实例）
import i18n from 'i18n';

const rootElement = document.getElementById('root');
const appTree = (
  <Provider store={store}>
    <React.StrictMode>
      <HelmetProvider>
        <I18nextProvider i18n={i18n}>
          <App />
        </I18nextProvider>
      </HelmetProvider>
      <ToastContainer
        autoClose={3000}
        closeOnClick
        draggable
        hideProgressBar
        newestOnTop
        pauseOnFocusLoss
        pauseOnHover
        position="top-right"
        rtl={false}
        transition={Flip}
      />
    </React.StrictMode>
  </Provider>
);

/**
 * 预渲染配合（scripts/prerender.js 构建期为每个路由生成静态 HTML）：
 * root 已有子节点说明命中了预渲染产物，用 hydrate 增量接管（用户首拍即见完整内容）；
 * 否则是普通 SPA 直达/开发模式，走 render 全量挂载。
 * 动画类组件（Counter 数字滚动、scroll reveal）hydrate 后会重新播放一次，属预期行为。
 */
if (rootElement && rootElement.hasChildNodes()) {
  ReactDOM.hydrate(appTree, rootElement);
} else if (rootElement) {
  ReactDOM.render(appTree, rootElement);
}
